import _ from 'lodash';

import config from '../config/config.json';

export function getCustomerType(typeId) {
  const type = typeId
    ? typeId !== config.clientTypeOld
      ? typeId
      : config.clientType
    : config.clientType;
  // console.log('getCustomerType', type);

  return type;
}

export function getMealLabel(mealId) {
  // console.log('getCustomerType', type);
  const label = _.filter(config.mealsTypes, ['id', parseInt(mealId)])[0].name;
  return label;
}

export function getCustomerTypeLabel(typeId) {
  const type = getCustomerType(typeId);
  const label = _.filter(config.personTypes, ['value', type])[0].label;
  // console.log('getCustomerTypeLabel', label);
  return label;
}

export function getMealCountLabel(meals) {
  let label = '';

  _.forEach(
    _(meals)
      .toPairs()
      .sortBy(0)
      .fromPairs()
      .value(),
    function(value, key) {
      label = label + `${getMealLabel(key)}: ${value} `;
    }
  );

  return label;
}

export default {
  getCustomerType,
  getCustomerTypeLabel,
  getMealCountLabel,
  getMealLabel
};
